import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatComponent } from 'src/app/model/cat-component.model';
import { CatComponentService } from 'src/app/services/cat-component.service';
import { ModalCatComponentComponent } from 'src/app/shared/modal-cat-component/modal-cat-component.component';

@Component({
  selector: 'app-cat-components',
  templateUrl: './cat-components.component.html',
  styleUrls: ['./cat-components.component.css']
})
export class CatComponentsComponent implements OnInit {
  // estado pagina
  public viewStatus = 0;  // -1:error, 0:spinner, 1:tabla
  public components: CatComponent[] = [];
  public flatComponents: CatComponent[] = []; // lista plana para tabla

  // opciones datatables
  dtOptions = {
    order: [],
    responsive: true,
    columnDefs: [
      { responsivePriority: 1, width: 100, targets: -1 }
    ],
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth: false,
    paging: true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private modalService: NgbModal,
    private catComponentService: CatComponentService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.getComponents();
  }

  //
  add = () => {
    let component = new CatComponent();
    component.canActivate = 'true';
    let modalRef = this.modalService.open(ModalCatComponentComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'dark-modal',
      size: 'lg'
    });
    modalRef.componentInstance.component = { ...component };
    modalRef.componentInstance.parentComponents = this.flatComponents;
    modalRef.componentInstance.mode = 'create';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getComponents();
      }
    );
  }

  edit = (component: CatComponent) => {
    let modalRef = this.modalService.open(ModalCatComponentComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'dark-modal',
      size: 'lg'
    });
    modalRef.componentInstance.component = { ...component };
    modalRef.componentInstance.parentComponents = this.flatComponents;
    modalRef.componentInstance.mode = 'edit';
    modalRef.result.then(
      data => console.log(data),
      reason => {
        console.log(reason);
        this.viewStatus = 0;
        this.getComponents();
      }
    );
  }

  // INFO
  getComponents = () => {
    this.catComponentService.getComponents()
      .pipe(
        tap((resp: any) => {
          this.components = resp.data || [];
          this.flatComponents = this.flattenComponents(this.components);
          this.viewStatus = 1;
        }),
        catchError(error => {
          this.viewStatus = -1;
          return of(this.toastr.error('Ocurrió un error al leer los componentes.'));
        })
      )
      .subscribe();
  }

  // Convertir estructura jerárquica a lista plana para DataTable
  flattenComponents = (components: CatComponent[], level = 0): CatComponent[] => {
    let result: CatComponent[] = [];
    components.forEach(comp => {
      const flatComp = { ...comp, level: level };
      result.push(flatComp as any);
      if (comp.componentChild && comp.componentChild.length > 0) {
        result = result.concat(this.flattenComponents(comp.componentChild as any, level + 1));
      }
    });
    return result;
  }

  // HELPERS
  getParentName = (parentId: string): string => {
    if (!parentId) return '-';
    const parent = this.flatComponents.find(c => c.componentId === parentId);
    return parent ? parent.componentName : '-';
  }

  getIndentation = (component: any): string => {
    const level = component.level || 0;
    return '—'.repeat(level) + (level > 0 ? ' ' : '');
  }
}
